module.exports = __webpack_public_path__ + "img/59_17.6291500b.png";